import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/common/Navbar";
import EditorSidebar from "@/components/editor/EditorSidebar";

const EditorDashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { profile } = useAuth();
  
  console.log("🎨 EditorDashboardLayout: Component mounted");
  console.log("🎨 EditorDashboardLayout: Profile:", profile);
  console.log("🎨 EditorDashboardLayout: Profile role:", profile?.role);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <EditorSidebar 
        isOpen={sidebarOpen} 
        basePath="/editor"
      />
      
      <div className="flex flex-col flex-1 overflow-hidden">
        <Navbar toggleSidebar={toggleSidebar} isAdmin={false} />
        
        <main className="flex-1 overflow-y-auto bg-gray-50 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default EditorDashboardLayout;